import {
  APP_TOAST_TYPES,
  TOP_NAVIGATION_BACKGROUND_TYPES,
} from "../constants/app-toast-types";

export const APP_DEFAULT_VALUE = {
  title: "",
  helpOptions: {
    open: false,
    title: "",
    pageTitle: "",
    list: [],
  },
  onBackPressed: null,
  backOptions: {
    open: false,
  },
  loader: {
    show: false,
  },
  alertOptions: {
    show: false,
    type: APP_TOAST_TYPES.SUCCESS,
    message: "",
    destination: "",
    pending: false,
  },
  topNavigationBackground: TOP_NAVIGATION_BACKGROUND_TYPES.DEFAULT,
};

export const AppContextActions = {
  //Title
  UPDATE_TITLE: "UPDATE_TITLE",
  //Help options
  OPEN_HELP_OPTIONS: "OPEN_HELP_OPTIONS",
  CLOSE_HELP_OPTIONS: "CLOSE_HELP_OPTIONS",
  UPDATE_HELP_OPTIONS_LIST: "UPDATE_HELP_OPTIONS_LIST",
  CLEAR_HELP_OPTIONS_LIST: "CLEAR_HELP_OPTIONS_LIST",
  UPDATE_PAGE_TITLE: "UPDATE_PAGE_TITLE",
  //Back pressed
  BACK_PRESSED: "BACK_PRESSED",
  //Back options
  OPEN_BACK_OPTIONS: "OPEN_BACK_OPTIONS",
  CLOSE_BACK_OPTIONS: "CLOSE_BACK_OPTIONS",
  //Loader
  SHOW_LOADER: "SHOW_LOADER",
  HIDE_LOADER: "HIDE_LOADER",
  //Alerts
  SHOW_SUCCESS_ALERT: "SHOW_SUCCESS_ALERT",
  SHOW_ERROR_ALERT: "SHOW_ERROR_ALERT",
  SET_PENDING_SUCCESS_ALERT: "SET_PENDING_SUCCESS_ALERT",
  SET_PENDING_ERROR_ALERT: "SET_PENDING_ERROR_ALERT",
  SHOW_PENDING_ALERT: "SHOW_PENDING_ALERT",
  HIDE_ALERT: "HIDE_ALERT",
  //TopNavigationBackground
  UPDATE_TOP_NAVIGATION_BACKGROUND: "UPDATE_TOP_NAVIGATION_BACKGROUND",
};

export const AppContextReducer = (state, action) => {
  switch (action.type) {
    //AppTopNavigation title update
    case AppContextActions.UPDATE_TITLE:
      return { ...state, title: action.value };
    //Help options
    case AppContextActions.OPEN_HELP_OPTIONS:
      return {
        ...state,
        helpOptions: {
          ...state.helpOptions,
          open: true,
        },
      };
    case AppContextActions.CLOSE_HELP_OPTIONS:
      return {
        ...state,
        helpOptions: {
          ...state.helpOptions,
          open: false,
        },
      };
    case AppContextActions.UPDATE_HELP_OPTIONS_LIST:
      return {
        ...state,
        helpOptions: {
          ...state.helpOptions,
          list: [...state.helpOptions.list, action.value],
        },
      };
    case AppContextActions.CLEAR_HELP_OPTIONS_LIST:
      return {
        ...state,
        helpOptions: {
          ...state.helpOptions,
          list: [],
        },
      };
    case AppContextActions.UPDATE_PAGE_TITLE:
      return {
        ...state,
        helpOptions: {
          ...state.helpOptions,
          pageTitle: action.value,
        },
      };
    //Back pressed
    case AppContextActions.BACK_PRESSED:
      return {
        ...state,
        onBackPressed: action.value,
      };
    //Back options
    case AppContextActions.OPEN_BACK_OPTIONS:
      return { ...state, backOptions: { ...state.backOptions, open: true } };
    case AppContextActions.CLOSE_BACK_OPTIONS:
      return { ...state, backOptions: { ...state.backOptions, open: false } };
    //Loader
    case AppContextActions.SHOW_LOADER:
      return { ...state, loader: { show: true } };
    case AppContextActions.HIDE_LOADER:
      return { ...state, loader: { show: false } };
    //Alerts
    case AppContextActions.SHOW_SUCCESS_ALERT:
      return {
        ...state,
        alertOptions: {
          show: true,
          type: APP_TOAST_TYPES.SUCCESS,
          pending: false,
          ...action.value,
        },
      };
    case AppContextActions.SHOW_ERROR_ALERT:
      return {
        ...state,
        alertOptions: {
          show: true,
          type: APP_TOAST_TYPES.ERROR,
          pending: false,
          ...action.value,
        },
      };
    case AppContextActions.SET_PENDING_SUCCESS_ALERT:
      return {
        ...state,
        alertOptions: {
          show: false,
          type: APP_TOAST_TYPES.SUCCESS,
          pending: true,
          ...action.value,
        },
      };
    case AppContextActions.SET_PENDING_ERROR_ALERT:
      return {
        ...state,
        alertOptions: {
          show: false,
          type: APP_TOAST_TYPES.ERROR,
          pending: true,
          ...action.value,
        },
      };
    case AppContextActions.SHOW_PENDING_ALERT:
      return {
        ...state,
        alertOptions: {
          ...state.alertOptions,
          show: true,
          pending: false,
        },
      };
    case AppContextActions.HIDE_ALERT:
      return {
        ...state,
        alertOptions: {
          show: false,
          type: APP_TOAST_TYPES.SUCCESS,
          message: "",
          destination: "",
          pending: false,
        },
      };
    //TopNavigationBackground
    case AppContextActions.UPDATE_TOP_NAVIGATION_BACKGROUND:
      return {
        ...state,
        topNavigationBackground: action.value,
      };
    default:
      return state;
  }
};
